<template>
	<div id="step4" class="sscw-container sscw-flex-column">
		<h2 id="top" class="sscw-step-title">
			{{ wizardContent.step4_header ? wizardContent.step4_header : "step4_header" }}
		</h2>
		<h3 class="step-description">
			{{ wizardContent.step4_Description ? wizardContent.step4_Description : "step4_Description" }}
		</h3>
		<div class="step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.grundrissIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.grundrissIcon" width="42px" alt="icon" />
				</div>
				<div class="sscw-w-full">
					<div class="sscw-step-input sscw-container">
						<div class="sscw-step-input-content">
							<div class="flex-col">
								<div class="flex-row">
									<div class="sscw-step-input-description">
										<span>
											{{
												wizardContent.step4_houseSize_label
													? wizardContent.step4_houseSize_label
													: "step4_houseSize_label"
											}}
										</span>
									</div>
									<div class="sscw-step-input-box">
										<input
											type="text"
											pattern="\d*"
											class="sscw-input"
											name="size"
											id="sscw-size"
											v-model="houseSizeDisplay"
											@blur="handleHouseSizeValidation"
											placeholder="150"
										/>
										<div class="sscw-input-suffix" v-show="houseSize < houseSizeOptions.max">m²</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="sscw-container flex">
						<div class="sscw-slider-container">
							<input
								type="range"
								v-model="houseSize"
								:min="houseSizeOptions.min"
								:max="houseSizeOptions.max"
								:step="houseSizeOptions.interval"
								@change="handleHouseSizeValidation"
							/>
						</div>

						<div class="sscw-slider-range-container">
							<div class="sscw-slider-range-label">{{ houseSizeOptions.min }}m²</div>
							<div class="sscw-slider-range-label">mehr als 500m²</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="houseType === 'SingleFamilyHouse'" class="step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.fenceIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.fenceIcon" width="42px" alt="icon" />
				</div>
				<div class="sscw-w-full">
					<div class="sscw-step-input sscw-container">
						<div class="sscw-step-input-content">
							<div class="flex-col">
								<div class="flex-row">
									<div class="sscw-step-input-description">
										<span>
											{{
												wizardContent.step4_house_propertySize_label
													? wizardContent.step4_house_propertySize_label
													: "step4_house_propertySize_label"
											}}
										</span>
									</div>
									<div class="sscw-step-input-box">
										<input
											type="text"
											pattern="\d*"
											:class="{ 'sscw-input': true }"
											name="size"
											id="sscw-size"
											v-model="propertySizeDisplay"
											@blur="handlePropertySizeValidation"
											placeholder="150"
										/>
										<div class="sscw-input-suffix" v-show="propertySize < propertySizeOptions.max">
											m²
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="sscw-container flex">
						<div class="sscw-slider-container">
							<input
								type="range"
								v-model="propertySize"
								:min="propertySizeOptions.min"
								:max="propertySizeOptions.max"
								:step="propertySizeOptions.interval"
								@change="handlePropertySizeValidation"
							/>
						</div>

						<div class="sscw-slider-range-container">
							<div class="sscw-slider-range-label">{{ propertySizeOptions.min }}m²</div>
							<div class="sscw-slider-range-label">mehr als {{ propertySizeOptions.max - 1 }}m²</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="step-image-group">
			<div class="sscw-mobile-hidden desktop-icon">
				<img :src="theme.kalenderIcon" width="42px" alt="icon" />
			</div>
			<div class="sscw-step-input-group">
				<div class="mobile-img sscw-desktop-hidden">
					<img :src="theme.kalenderIcon" width="42px" alt="icon" />
				</div>
				<div class="sscw-w-full">
					<div class="sscw-step-input sscw-container">
						<div class="sscw-step-input-content">
							<div class="flex-col">
								<div class="flex-row">
									<div class="sscw-step-input-description">
										<span>
											{{
												wizardContent.step4_constructionYear_label
													? wizardContent.step4_constructionYear_label
													: "step4_constructionYear_label"
											}}
										</span>
									</div>
									<div
										:class="{ 'sscw-step-input-box': true, 'has-error': showConstructionYearError }"
									>
										<input
											type="text"
											pattern="\d*"
											:class="{ 'sscw-input': true }"
											name="size"
											id="sscw-size"
											v-model="constructionYear"
											@blur="handleConstructionYearValidation"
											placeholder="1980"
										/>
									</div>
									<div class="error-message" v-if="showConstructionYearError">
										{{
											wizardContent.step4_constructionYear_errorMessage
												? wizardContent.step4_constructionYear_errorMessage
												: "step4_constructionYear_errorMessage"
										}}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import getTheme from "@/utils/theme";
import wizardContent from "@/utils/extnWizardContent";
const MIN_CONSTRUCTION_YEAR = 1700;

export default {
	name: "ClickWizardStep4",
	data() {
		return {
			theme: getTheme(),
			wizardContent: wizardContent(),
			showConstructionYearError: false,
			propertySizeOptions: {
				min: 40,
				max: 3001,
				interval: 1,
			},
			houseSizeOptions: {
				dotSize: 22,
				height: 4,
				width: "auto",
				direction: "ltr",
				data: null,
				dataLabel: "label",
				dataValue: "value",
				min: 40,
				max: 501,
				interval: 1,
				clickable: true,
				duration: 0.5,
				dotStyle: {
					"background-color": "#112C42",
				},
				processStyle: {
					"background-color": "#112C42",
				},
			},
		};
	},

	mounted() {
		if (!this.houseType) {
			this.houseType = "SingleFamilyHouse";
		}
		this.emitUpdate();
		this.$emit("onValidation", this.validateStep());

		this.$nextTick(() => {
			document
				.querySelector("#shortcode-2-977 > ss-lebenswert-wizard-extn")
				?.shadowRoot.querySelector("#top")
				?.scrollIntoView();
			window.scrollTo(0, -150);
		});
	},
	methods: {
		emitUpdate() {
			this.$emit("updated", {
				houseSize: this.houseSize,
				propertySize: this.propertySize,
			});
		},
		validateStep() {
			return true;
		},
		constructionYearValidation(inputData) {
			if (!isNaN(inputData) && inputData > MIN_CONSTRUCTION_YEAR && inputData < new Date().getFullYear()) {
				this.showConstructionYearError = false;
				this.isConstructionYearValid = true;
				return true;
			}
			this.showConstructionYearError = true;
			this.isConstructionYearValid = false;
			return false;
		},
		handleConstructionYearValidation(event) {
			this.constructionYearValidation(event.target.value);
			this.$emit("onValidation", this.validateStep());
		},
		houseSizeValidation(inputData) {
			if (inputData) {
				return (this.isHouseSizeValid = true);
			}
			return (this.isHouseSizeValid = false);
		},
		handleHouseSizeValidation(event) {
			this.houseSizeValidation(event.target.value);
			this.$emit("onValidation", this.validateStep());
		},
		propertySizeValidation(inputData) {
			if (inputData) {
				return (this.isPropertySizeValid = true);
			}
			return (this.isPropertySizeValid = false);
		},
		handlePropertySizeValidation(event) {
			this.propertySizeValidation(event.target.value);
			this.$emit("onValidation", this.validateStep());
		},
	},
	computed: {
		wizardState() {
			return this.$store.wizardState;
		},
		houseType: {
			get() {
				return this.$store.wizardState.houseType;
			},
			set(value) {
				this.$store.wizardState.houseType = value;
			},
		},
		houseSize: {
			get() {
				return this.$store.wizardState.houseSize;
			},
			set(value) {
				this.$store.wizardState.houseSize = value;
			},
		},
		propertySize: {
			get() {
				return this.$store.wizardState.propertySize;
			},
			set(value) {
				this.$store.wizardState.propertySize = value;
			},
		},
		constructionYear: {
			get() {
				return this.$store.wizardState.constructionYear;
			},
			set(value) {
				this.$store.wizardState.constructionYear = value;
			},
		},
		isHouseSizeValid: {
			get() {
				return this.$store.wizardState.isHouseSizeValid;
			},
			set(value) {
				this.$store.wizardState.isHouseSizeValid = value;
				this.$emit("onValidation", this.validateStep());
			},
		},
		isPropertySizeValid: {
			get() {
				return this.$store.wizardState.isPropertySizeValid;
			},
			set(value) {
				this.$store.wizardState.isPropertySizeValid = value;
				this.$emit("onValidation", this.validateStep());
			},
		},
		isConstructionYearValid: {
			get() {
				return this.$store.wizardState.isConstructionYearValid;
			},
			set(value) {
				this.$store.wizardState.isConstructionYearValid = value;
				this.$emit("onValidation", this.validateStep());
			},
		},
		houseSizeDisplay: {
			get() {
				if (this.houseSize < 501) return this.houseSize;
				return "mehr als 500m²";
			},
			set(newValue) {
				if (typeof newValue == "string" && newValue.includes("mehr")) {
					this.houseSize = 501;
				} else if (newValue < 501 && newValue > 0) {
					this.houseSize = newValue;
				} else if (newValue > 501) {
					this.houseSize = 501;
				} else if (newValue < 40) {
					this.houseSize = 40;
					return;
				}
				this.$forceUpdate();
			},
		},
		propertySizeDisplay: {
			get() {
				if (this.propertySize < this.propertySizeOptions.max) return this.propertySize;
				return `mehr als ${this.propertySizeOptions.max - 1}m²`;
			},
			set(newValue) {
				if (typeof newValue == "string" && newValue.includes("mehr")) {
					this.propertySize = this.propertySizeOptions.max;
				} else if (newValue < this.propertySizeOptions.max && newValue > 0) {
					this.propertySize = newValue;
				} else if (newValue > this.propertySizeOptions.max) {
					this.propertySize = this.propertySizeOptions.max;
				} else if (newValue < this.propertySizeOptions.min) {
					this.propertySize = this.propertySizeOptions.min;
					return;
				}
				this.$forceUpdate();
			},
		},
	},
};
</script>
<style scoped>
.jump-to-top {
	visibility: hidden;
}
.error-message {
	color: red;
}
.step-image-group {
	display: flex;
	gap: 34px;
	align-items: center;
}

.flex-col {
	display: flex;
	flex-direction: column;
}

.sscw-flex-column {
	gap: 24px;
	display: flex;
	flex-direction: column;
}

.sscw-step-input-group {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	gap: 6px;
}

.mobile-img {
	margin-left: 14px;
}

.sscw-w-full {
	flex: 1;
}

.sscw-step-input-description {
	display: flex;
}

@media (min-width: 1190px) {
	.sscw-step-input-group {
		width: 683px;
		padding: 33px 0;
	}

	.flex-col {
		width: 100%;
	}

	.flex-row {
		display: flex;
		gap: 16px;
		flex-direction: column;
	}
}

.step-description {
	margin: unset;
}
</style>
